<template>
    <div>
        <div id="sq-ccbox">

            <div class="errorbox">
                <div class="error" v-for="error in uniqueSquareErrors" :key="error">
                    {{ error }}
                </div>
            </div>
            <div id="card-tainer">
                <div class="cardfields card-number" :id="id+'-sq-card-number'">o</div>
                <div class="cardfields expiration-date" :id="id+'-sq-expiration-date'">e</div>
                <div class="cardfields cvv" :id="id+'-sq-cvv'">e</div>
                <div class="cardfields postal-code" :id="id+'-sq-postal-code'">e</div>
            </div>

            <input type="hidden" id="card-nonce" name="nonce">
            <div id="sq-walletbox">
            </div>
        </div>
        <button @click="paymentForm.requestCardNonce()" class='productPurchase payButton'>Save Credit Card</button>
    </div>
</template>

<script>
import Payments from "@/api/Payments";
export default {
    name : "SquareCard",
    props : {
        id : String,
        activeProvider : {
            type : Object,
            required : true,
        },
        ccMethod : {
            type : Object,
            required : true,
        }
    },
    data : function () {
        return {
            squareErrors : [],
            saving : false,
        };
    },
    computed : {
        providerId() {
            return this.activeProvider.id;
        },
        methodId() {
            return this.ccMethod.id;
        },
        uniqueSquareErrors() {
            return [...new Set(this.squareErrors)];
        },
        applicationSetting() {
            return this.activeProvider.settings
                .find(s => s.key === "square_application_id");
        },
        applicationId() {
            return this.applicationSetting ? this.applicationSetting.value : null;
        }
    },
    mounted() {
        let that = this;
        this.paymentForm = new SqPaymentForm({
            autoBuild : false,
            applicationId : that.applicationId,
            inputClass : "sq-input",
            // Initialize the payment form elements

            // Customize the CSS for SqPaymentForm iframe elements
            inputStyles : [
                {
                    fontSize : ".9em"
                }
            ],

            // Initialize the credit card placeholders
            cardNumber : {
                elementId : that.id + "-sq-card-number",
                placeholder : "Card number"
            },
            cvv : {
                elementId : that.id + "-sq-cvv",
                placeholder : "CVV"
            },
            expirationDate : {
                elementId : that.id + "-sq-expiration-date",
                placeholder : "MM / YY"
            },
            postalCode : {
                elementId : that.id + "-sq-postal-code",
                placeholder : "Zip Code"
            },

            callbacks : {

                /*
                   * callback function: cardNonceResponseReceived
                   * Triggered when: SqPaymentForm completes a card nonce request
                */
                cardNonceResponseReceived : function (receivedErrors, nonce, cardData) {

                    if (receivedErrors) {
                        receivedErrors.forEach(function (error) {
                            that.squareErrors.push(error.message);
                        });
                        return;
                    }

                    const constRequestBody = {
                        methodId : that.methodId,
                        providerId : that.providerId,

                        nonce : nonce,
                    };
                    Payments.createSquarePaymentCard(constRequestBody).then(tokenResponse => {
                        let squareMetadata = tokenResponse.data;
                        that.$emit('create-payment-method', {
                            method : {
                                paymentProviderId : that.providerId,
                                paymentProviderMethodId : that.methodId,
                                last4 : cardData.last_4,
                                metaData : JSON.stringify(squareMetadata),
                            },
                            settings : [
                                {
                                    key : 'nonce',
                                    value : nonce,
                                    accountPaymentProviderId : that.activeProvider.accountPaymentProvider.id
                                },
                                {
                                    key : 'square_customer_id',
                                    value : squareMetadata.customer_id,
                                    accountPaymentProviderId : that.activeProvider.accountPaymentProvider.id
                                },
                                {
                                    key : 'square_card_id',
                                    value : squareMetadata.card.id,
                                    accountPaymentProviderId : that.activeProvider.accountPaymentProvider.id
                                }
                            ]
                        });
                    });
                },
                /*
                   * callback function: paymentFormLoaded
                   * Triggered when: SqPaymentForm is fully loaded
                */
                paymentFormLoaded : function () {

                }
            }
        });

        this.paymentForm.build();
    },
    methods : {
        requestCardNonce : function (event) {

            // Don't submit the form until SqPaymentForm returns with a nonce
            event.preventDefault();

            // Request a nonce from the SqPaymentForm object
            this.paymentForm.requestCardNonce();
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.sq-input {
    border: 1px solid rgb(223, 223, 223);
    outline-offset: -2px;
    margin-bottom: 5px;
    display: inline-block;
    color: #32325d;
    line-height: 18px;
    font-family: "Helvetica Neue", Helvetica, sans-serif;
    font-size: 16px;
    height: 18px;
    -webkit-font-smoothing: antialiased;
}

.sq-input ::placeholder {
    color: #aab7c4;
    opacity: 0.5;
}

.sq-input--error {
    outline: 3px auto rgb(255, 97, 97);
}

.errorbox {
    line-height: 14px;
    text-align: left;
}

.error {
    font-size: 10px;
    color: rgb(164, 0, 30);
    width: 45%;
    display: inline-block;

    margin-top: -10px;
    font-weight: 400;
}

/* Customize the "Pay with Credit Card" button */

.button-credit-card {
    min-width: 200px;
    min-height: 20px;
    padding: 0;
    margin: 5px;
    line-height: 20px;
    box-shadow: 2px 2px 1px rgb(200, 200, 200);
    background: rgb(255, 255, 255);
    border-radius: 5px;
    border: 1px solid rgb(200, 200, 200);
    font-weight: bold;
    cursor: pointer;
}

.card-number {
    width: 100%;
}

.modal .payButton {
    margin-left : 0px;
    position : absolute;
    bottom : 0px;
    width: 400px;
}

#sq-walletbox {
    text-align: center;
    vertical-align: top;
    font-weight: bold;
}

#sq-ccbox {
    margin: 5px;
    padding: 0px 10px;
    text-align: center;
    vertical-align: top;
    font-weight: bold;
}

.expiration-date,
.cvv,
.postal-code {
    width: 30%;
    display: inline-block;
}

#card-tainer {
    text-align: left;
    margin-top: 8px;
    background-color: white;
    height: 80px;
    padding: 10px 12px;
    border-radius: 4px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    border: 1px solid transparent;
    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
    box-sizing: border-box;
}
</style>
